import script from "./CategorySidebar.vue?vue&type=script&setup=true&lang=js"
export * from "./CategorySidebar.vue?vue&type=script&setup=true&lang=js"

import "./CategorySidebar.vue?vue&type=style&index=0&id=4885ae08&scoped=true&lang=css"

import exportComponent from "/var/www/levsha/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4885ae08"]])

export default __exports__